<template>
	<div>
		<b-modal ref="loaderModal"
			hide-footer
			title="Chargement...">
			<p class="my-4">{{ $t("interactions.wait_for_project") }}</p>
		</b-modal>
		<b-modal ref="modalThematic"
			hide-footer
			title="Erreur">
			<lottie_error />
			<p class="my-4">{{ text_error }}</p>
		</b-modal>

		<div class="col-12 mt-4">
			<div class="valid_button">
				<button type="submit"
					class="btn btn-valid"
					@click.prevent="createProject">{{ $t('Button.validate_selection') }}
				</button>
			</div>
		</div>
	</div>
</template>

<script>
import axios from "axios";
import lottie_error from "@/components/ui/lottie_error";

const BASE_URL = process.env.VUE_APP_BASE_URL;

export default {
	name: "ValidThematicSelection",
	components: {lottie_error},
	props: {
		thematics: Array,
	},
	data: function () {
		return {
			text_error: "",
		};
	},
	methods: {
		createProject() {
			let count = 0;
			if (sessionStorage.getItem("thematic")) {
				sessionStorage.removeItem("thematic");
			}
			for (let i = 0; i <= this.thematics.length - 1; i++) {
				if (this.thematics[i].isSelected) {
					count++;
					sessionStorage.setItem("thematic", this.thematics[i].name);
				}
			}
			if (count !== 1) {
				this.$refs.modalThematic.show();
				this.text_error = "You must select a theme to be able to create a new project.";
			}
			else {
				this.sendDatas();
			}
		},
		sendDatas: function () {
			let data = {
				project: {
					name: "Nouveau projet",
					id: -1,
					thematicId: sessionStorage.getItem("thematic"),
					username: sessionStorage.getItem("username"),
					// width: process.env.VUE_APP_CLIENT,
				},
			};
			let body = JSON.stringify(data);
			this.$refs.loaderModal.show();
			// axios({
			// 	url: BASE_URL + "/public/api/projects",
			// 	data: {
			// 		data: body,
			// 	},
			// 	method: "POST",
			// 	config: {
			// 		headers: {
			// 			"Content-Type": "multipart/form-data",
			// 			"Authorization": sessionStorage.getItem("auth"),
			// 		},
			// 	},
			// })
			let bodyFormData = new FormData();
			bodyFormData.append("data", body);

			axios.post(BASE_URL + "/public/api/projects",
				bodyFormData,
				{
					headers: {
						"Content-Type": "multipart/form-data",
						"Authorization": sessionStorage.getItem("auth"),
					},
				},
			)
			.then(response => {
				this.$refs.loaderModal.hide();
				sessionStorage.removeItem("thematic");
				this.$router.push({name: "ProjectEdition", params: {id: response.data.data.id}});
			}).catch(error => {
				this.$refs.loaderModal.hide();
				this.text_error = this.$root.$t("Errors.message_general") + error;
				this.$refs.modalThematic.show();
			});
		},
	},
	beforeDestroy() {
		sessionStorage.removeItem("thematic");
		this.text_error = "";
	},
};
</script>

<style scoped>
.btn-valid {
	background-color: var(--color-validation);
	border-color: var(--color-validation);
	color: var(--text-validation);
	border-radius: var(--small-border-radius);
}
</style>
